import cn from "classnames";
import styles from './Switch.module.scss';

interface ISwitchProps {
  checked: boolean;
  disabled?: boolean;
  titleOnLeft?: boolean;
  onChange: () => void;
  title: string;
}

const Switch: React.FC<ISwitchProps> = ({
  checked,
  disabled,
  titleOnLeft,
  onChange,
  title,
}: ISwitchProps): React.ReactElement => {
  return (
    <div
      className={cn(
        styles.root,
        titleOnLeft && styles.titleOnLeft,
        disabled && styles.disabled,
        checked && styles.checked,
      )}
      onClick={onChange}
    >
      <span className={styles.switch} />
      <input
        checked={checked}
        className={styles.input}
        onChange={onChange}
        type="checkbox"
      />
      <span className={styles.text}>
        {title}
      </span>
    </div>
  );
};

export default Switch;
